// @core/api/endpoints/document/register_document_type.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DocumentTypeDefinitionResponse,
  RegisterDocumentTypeRequest,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Register document type
 * Registers a new document type definition. Products call this to declare their document-aware entity types (e.g., hr.order, billing.invoice). Once registered, DocumentService will handle numbering, versioning, and lifecycle for entities of this type.
 */
export async function RegisterDocumentType(
  data: RegisterDocumentTypeRequest,
  options?: RequestOptions
): Promise<DocumentTypeDefinitionResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/document-types`;
  const requestOptions = options;
  return client.post<DocumentTypeDefinitionResponse>(requestPath, data, requestOptions);
}
